import { ImageGalleryElement } from '../../components/reusable-elements/image-gallery-element';
import './gallery.css';

export const PropertyGalleryTab = ({ photos, setShowUploadImageModal, setShowEditImageModal, setStarRating }) => {

    return (
        <div className="tab-pane fade" id="nav-pills-tab-gallery">
            <div className="gallery-container">
                <div className="gallery-header">
                    <h3 className="gallery-title">
                        <i className="fa fa-images"></i>
                        Property Photos
                    </h3>
                    <div className="gallery-actions">
                        <button 
                            className="btn btn-add-photos"
                            onClick={() => setShowUploadImageModal(true)}
                            title="Add New Photos"
                        >
                            <i className="fa fa-plus"></i>&nbsp;&nbsp;Add Photos
                        </button>
                    </div>
                </div>
                
                <ImageGalleryElement
                    key={"Photos"}
                    photos={photos ?? []}
                    setShowUploadImageModal={setShowUploadImageModal}
                    setShowEditImageModal={setShowEditImageModal}
                    setStarRating={setStarRating}
                />
            </div>
        </div>
    );
}